module.exports = __webpack_public_path__ + "img/Frame_07.097f13c2.png";